<template>
  <div>
    <v-container fluid class="pa-0">
      <v-btn
        dark
        style="margin-top:97px"
        class="float-right mr-5"
        color="#636262"
        fab
        @click="openSetting()"
        v-if="mode && all_preview.length == 0"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-carousel
        cycle
        :hide-delimiters="all_preview.length <= 1"
        :show-arrows="false"
        height="100vh"
        style="margin-top:-97px"
      >
        <!-- <pre>{{all_preview}}</pre> -->
        <v-carousel-item
          v-for="(item, i) in all_preview"
          :key="i"
          :src="env + item.image_cover_file_path"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-row style="margin-top:97px;" justify="center" align="center">
            <v-col align="right" cols="12">
              <v-btn
                class="float-right ma-5"
                color="#636262"
                fab
                @click="openSetting()"
                v-if="mode"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- style="margin-top:80px; color:#ffffff; font-family: 'sukhumvit_setsemi_bold'; text-shadow: 3px 3px #000000
; background-color: rgba(255, 255, 255, 0.4);
          background-image: linear-gradient( rgba(255, 255, 255, 0.6), rgba(0, 0, 0, 0.1)); "-->
          <v-row
            justify="center"
            align="center"
            :style="
              mode == true
                ? {
                    'margin-right': '300px',
                    'margin-left': '300px',
                    'margin-top': '-30px',
                    color: '#3e046b',
                    height: '300px',
                    'background-color': 'rgba(255, 255, 255, 0.5)',
                    'font-family': 'sukhumvit_setsemi_bold',
                    'background-image':
                      'linear-gradient( rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2))'
                  }
                : {
                    'margin-right': '300px',
                    'margin-left': '300px',
                    'margin-top': '30px',
                    color: '#3e046b',
                    height: '300px',
                    'background-color': 'rgba(255, 255, 255, 0.5)',
                    'font-family': 'sukhumvit_setsemi_bold',
                    'background-image':
                      'linear-gradient( rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2))'
                  }
            "
          >
            <!-- <v-col cols="12">
              <v-row class="mt-0" align="center" justify="center">
                <v-col cols="6" align="right" class="py-0">
                  <v-img width="120" src="../../assets/image/logo2.png"></v-img>
                </v-col>
                <v-col cols="6" align="left" class="py-0">
                  <v-img width="150" src="../../assets/image/logo1.png"></v-img>
                </v-col>
              </v-row>
            </v-col>-->
            <v-col cols="10" align="center">
              <v-container class="py-0" style="border: 3px solid rgba(255, 255, 255, 1)">
                <p style="font-size:50px; text-shadow: 2px 2px  grey; ">สาขาวิชาวิสัญญีวิทยา</p>
                <p style="font-size:50px; text-shadow: 2px 2px  grey; color:#053D05;">คณะแพทยศาสตร์</p>
                <p
                  style="font-size:50px; text-shadow: 2px 2px  grey; color:#053D05;"
                >มหาวิทยาลัยสงขลานครินทร์</p>
              </v-container>
            </v-col>
          </v-row>
          <v-card
            light
            style="z-index:1;background-image: linear-gradient(to right, #f2f2f2 ,#ffffff);position: absolute;
                    bottom:50px;
                    right: 380px;
                    width: 280px;
                    height: 190px;
                    border-radius: 140px 0px 0px 140px;
                    text-align: right;
                    "
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-card-title v-bind="attrs" v-on="on" class="text-right">
                  <v-spacer></v-spacer>
                  <span class="text-right">{{ lenght_topic(all_preview[i].topic1) }}</span>
                </v-card-title>
              </template>

              <span style="font-size:22px;">{{all_preview[i].topic1}}</span>
            </v-tooltip>

            <v-card-text class="py-0" style="white-space: pre-wrap;">
              <span>{{ lenght_data(all_preview[i].description1) }} &#10;</span>
              <br />
              <span>{{ lenght_data(all_preview[i].description1_1) }} &#10;</span>
              <br />
              <span>{{ lenght_data(all_preview[i].description1_2) }} &#10;</span>
            </v-card-text>
            <!-- <v-card-text
              class="py-0"
              style="white-space: pre-wrap;"
            >{{ lenght_data(all_preview[i].description1_1) }}&#10;</v-card-text>
            <v-card-text
              class="py-0"
              style="white-space: pre-wrap;"
            >{{ lenght_data(all_preview[i].description1_2) }}&#10;</v-card-text>-->
            <!-- <v-card-text class="py-0">09.00 - 11.00 น.</v-card-text>
            <v-card-text class="py-0"
              >แพทย์หญิงศศิกานต์ นิมมานรัชต์</v-card-text
            >-->
            <v-card-actions class="mr-2 mt-2">
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                style="color:#000000  "
                small
                @click="goLink('/subunits?id=' + all_preview[i].link1)"
              >เพิ่มเติม</v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-card
            tile
            style="z-index:2;position: absolute;background-image: linear-gradient(to right, #fd746c  ,#ff9068);
                     bottom:50px;
                    right: 370px;
                    width: 12px;
                    height: 190px;
                   
                  "
          ></v-card>-->
          <v-card
            style="z-index:1;position: absolute;background-image: linear-gradient(to left, #fd746c  ,#ff9068);
                     bottom:50px;
                    right: 95px;
                    width: 280px;
                    height: 190px;
                    border-radius: 0px 140px 140px 0px;
                  "
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-card-title v-bind="attrs" v-on="on" class="mr-12 pr-12">
                  <span>{{ lenght_topic(all_preview[i].topic2) }}</span>
                </v-card-title>
              </template>

              <span style="font-size:22px;">{{all_preview[i].topic2}}</span>
            </v-tooltip>

            <v-card-text class="mr-12 pr-12 py-0">
              <span
                style="white-space: pre-wrap;"
              >{{ lenght_data(all_preview[i].description2) }}&#10;</span>

              <br />
              <span>{{ lenght_data(all_preview[i].description2_1) }} &#10;</span>
              <br />
              <span>{{ lenght_data(all_preview[i].description2_2) }} &#10;</span>
            </v-card-text>
            <!-- <v-card-text class="mr-12 pr-12 py-0">09.00 - 11.00 น.</v-card-text>
            <v-card-text class="mr-12 pr-12 py-0"
              >แพทย์หญิงนลินี โกวิทวนาวงษ์</v-card-text
            >-->
            <v-card-actions class="ml-2 mt-2">
              <v-btn
                color="white"
                style="color:#fd746c  "
                small
                @click="goLink('/subunits?id=' + all_preview[i].link2)"
              >เพิ่มเติม</v-btn>
            </v-card-actions>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <DialogPreview ref="dialog_preview_setting"></DialogPreview>
  </div>
</template>
<script>
import DialogPreview from "../Settings/DialogPreview";
import "animate.css";
export default {
  components: {
    DialogPreview,
  },
  data() {
    return {
      mode: false,
      env: process.env.VUE_APP_API,
      // all_preview: [],
      // items: [
      //   {
      //     src: require(`../../assets/image/bg.jpg`)
      //   },
      //   {
      //     src: require("../../assets/image/bg6.png")
      //   }
      // ]
    };
  },
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;

    this.getPreview();
    this.postViewCount();
  },
  computed: {
    all_preview() {
      return this.$store.state.preview_img;
    },
  },
  methods: {
    openSetting() {
      this.$refs.dialog_preview_setting.openSetting();
    },
    getPreview() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/image_cover/")
        .then((response) => {
          let preview = [];
          // console.log("PREVIEW");
          // console.log(response.data);
          preview = response.data;
          this.$store.state.preview_img = preview;
          // this.all_preview = preview;
        });
    },
    postViewCount() {
      let data = {
        viewcount_catagory: "home",
      };
      this.axios.post(process.env.VUE_APP_API + "/api/v1/viewcount", data);
    },
    goLink(link) {
      // console.log(link);
      // window.open(link, "_blank");
      this.$router.push(link);
    },
    lenght_data(data) {
      const max_lenght = 37;
      let data_string = "";
      for (let index = 0; index < max_lenght; index++) {
        data_string += data[index];
      }
      data_string += "...";
      if (data.length < max_lenght) {
        return data;
      } else {
        return data_string;
      }
    },
    lenght_topic(data) {
      const max_lenght = 17;
      let data_string = "";
      for (let index = 0; index < max_lenght; index++) {
        data_string += data[index];
      }
      data_string += "...";
      if (data.length < max_lenght) {
        return data;
      } else {
        return data_string;
      }
    },
  },
};
</script>
<style></style>
